import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';

// todo: move to hooks
export function HOOK_ML_ASSET__get_by_hash(hash: string) {
  /*
   * STORE
   */

  const { ml_assets_map } = use_slice_ml_asset(['ml_assets_map']);

  /*
   * RESULT
   */

  let out = DTO__ml_asset.CREATE_STUB();

  for (let ml_asset of ml_assets_map.values()) {
    if (ml_asset.hash_sha256 != hash) continue;

    out = ml_asset;

    break;
  }

  return out;
}
